module.exports = __webpack_public_path__ + "img/finish.b0e7e726.png";